/** Error base de las peticiones HTTP: mensaje + código de estado. Las subclases
 *  fijan el `status` por tipo (400/401/404/500…). */
export class HttpError extends Error {
  /**
   * @param message Mensaje de error.
   * @param status  Código de estado HTTP asociado.
   */
  public constructor(
    public message: string,
    public status: number,
  ) {
    super(message);
    this.name = "HttpError";
  }
}
